









import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component
export default class NumberInput extends Vue {
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: false }) dispZero!: boolean;
  @Prop({ default: false }) isNull!: boolean;
  @Prop({ default: false }) hiddenSpin!: boolean;

  @Emit()
  private input(value: string): number | null {
    if (value === "" && this.isNull) {
      return null;
    }
    const nam = Number(value);
    if (isNaN(nam)) {
      return 0;
    }
    return nam;
  }

  private get Value(): string {
    if (this.value === null && this.isNull) {
      return "";
    }
    if (this.value === 0 && !this.dispZero) {
      return "";
    }
    return this.value.toString();
  }

  private set Value(value: string) {
    this.input(value);
  }
}
